import { render } from "./EtatEmpList.vue?vue&type=template&id=4f384baa"
import script from "./EtatEmpList.vue?vue&type=script&lang=ts"
export * from "./EtatEmpList.vue?vue&type=script&lang=ts"
script.render = render

export default script